var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.product
    ? _c("div", [
        _c(
          "div",
          { staticClass: "box-toggle-switch" },
          [
            _vm.arrayFnskuKbn.length
              ? [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.product.fnskuKbn,
                        expression: "product.fnskuKbn"
                      }
                    ],
                    staticClass: "switch-input",
                    attrs: {
                      type: "checkbox",
                      id: "fnsku-kbn-" + _vm.product.asin
                    },
                    domProps: {
                      checked: Array.isArray(_vm.product.fnskuKbn)
                        ? _vm._i(_vm.product.fnskuKbn, null) > -1
                        : _vm.product.fnskuKbn
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.product.fnskuKbn,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.product,
                                "fnskuKbn",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.product,
                                "fnskuKbn",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.product, "fnskuKbn", $$c)
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("label", {
                    staticClass: "switch-label",
                    attrs: { for: "fnsku-kbn-" + _vm.product.asin },
                    on: {
                      click: function($event) {
                        _vm.update()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    { class: _vm.getStatusItem.class + " switch-title" },
                    [_vm._v(_vm._s(_vm.getStatusItem.status))]
                  )
                ]
              : [
                  _c("input", {
                    staticClass: "switch-input",
                    attrs: { type: "checkbox" },
                    domProps: { checked: false }
                  }),
                  _vm._v(" "),
                  _c("label", {
                    staticClass: "switch-label switch-label-gray"
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "text-gray switch-title" }, [
                    _vm._v("FNSKUを利用しない")
                  ])
                ]
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "m-t-sm" },
          [
            _vm.product.fnskuKbn
              ? [
                  _vm.arrayFnskuKbn.length > 1
                    ? _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.product.fnsku,
                              expression: "product.fnsku"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            name: "fnsku-kbn",
                            id: "fnsku-kbn-select-" + _vm.product.asin
                          },
                          on: {
                            change: [
                              function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.product,
                                  "fnsku",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                              function($event) {
                                _vm.changeFnsku()
                              }
                            ]
                          }
                        },
                        _vm._l(_vm.arrayFnskuKbn, function(arrItem, arrIndex) {
                          return _c(
                            "option",
                            { key: arrIndex, domProps: { value: arrItem } },
                            [_vm._v(_vm._s(arrItem))]
                          )
                        }),
                        0
                      )
                    : _vm.arrayFnskuKbn.length === 1
                    ? _c("div", { staticClass: "m-t" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.product.fnsku) +
                            "\n        "
                        ),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.product.fnsku,
                              expression: "product.fnsku"
                            }
                          ],
                          attrs: { type: "hidden" },
                          domProps: { value: _vm.product.fnsku },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.product,
                                "fnsku",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    : _c("div", { staticClass: "m-t" }, [
                        _c("div", { staticClass: "text-gray m-t" }, [
                          _vm._v(_vm._s(_vm.formatFnsku))
                        ])
                      ])
                ]
              : [
                  _c("div", { staticClass: "text-gray m-t" }, [
                    _vm._v(_vm._s(_vm.formatFnsku))
                  ])
                ]
          ],
          2
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-690d4278", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-690d4278","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/deliveryRequests/components/FnskuKbnItem.vue
// module id = null
// module chunks = 